import { render, staticRenderFns } from "./myArea.vue?vue&type=template&id=54ec890e&"
import script from "./myArea.vue?vue&type=script&lang=ts&"
export * from "./myArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports